import React from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useQuery } from "@tanstack/react-query";
import { getScheduleByDay } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import SessionScheduleTable from "components/common/schedule/SessionScheduleTable";
import Label from "components/general/Label";
import { dateFormat, SELECTOR_DISPLAY_TYPE, sortDataByField, TYPE_DATA } from "helpers/utils";
import { useLocation } from "react-router-dom";
import { Accordion, Stack } from "react-bootstrap";
import PageHeader from "components/common/PageHeader";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";

const ScheduleByDay = () => {
  const { mirs_competition, mirs_language, mirs_noc, mirs_date } =
    useUrlFriendlyToParameters();
  const location = useLocation();
  const { state: item } = location;
  const { data, isError, isLoading } = useQuery({
    queryKey: ["scheduleDataByDay", mirs_competition, mirs_language, mirs_date],
    queryFn: getScheduleByDay,
    refetchInterval: 5000,
    staleTime: 5000,
    refetchIntervalInBackground: true,
    notifyOnChangeProps: ["data", "error"],
    //enabled: !!confCategory
    onError: (error) => console.error(`Something went wrong: ${error.message}`),
  });

  if (isError) {
    return <NotAvailable />;
  }
  if (isLoading) {
    return <Loader />;
  }
  if (!data?.schedules) {
    return <NotAvailable />;
  }

  //we need to filter by phase type
  const filteredData = data?.schedulesByNoc?.filter((u) =>
    u.eventUnit.phase.type.match("[13]")
  );

  sortDataByField(filteredData, "startDate", true, TYPE_DATA.DATE);

  // Create a Map to hold discipline data
  const disciplineMap = new Map();
  data.schedules.forEach((schedule) => {
    const { discipline } = schedule;
    disciplineMap.set(discipline.code, discipline.description);
  });
  // let disciplineCodes = data?.schedules?.map(x =>  (x.discipline.description));
  let disciplineCodes = data?.schedules?.map((x) => x.discipline.code);


  return (
    <>
      <div className="mirs-page-container">

        <Stack direction="horizontal">
          <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="schedulebyday" />
        </Stack>
        {disciplineCodes.map((disciplineCode, index) => {
          return (
            <div key={index}>
              <Accordion className="schedule-container" defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Body className="p-0">
                    <SessionScheduleTable
                      data={data?.schedules?.filter(
                        (e) => e.discipline.code === disciplineCode
                      )}
                      header={disciplineMap.get(disciplineCode)}
                      key={`schedule-${mirs_noc}`}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ScheduleByDay;
